<template>
        <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
  <el-table :data="tableData" style="width: 100%;" :default-sort="{prop: 'date', order: 'descending'}" empty-text="wait"
    >
    <!-- <el-table-column
            prop="name"
            label="currency"
            sortable
            width="150">
            <font color="#DCDCDC">/USDT</font>
          </el-table-column> -->
    <el-table-column prop="date" label="Date" width="180" sortable>
    </el-table-column>
    <el-table-column prop="buyVol" label="BuyVol" sortable filter-placement="bottom-end">
      <template slot-scope="scope">
        <p style="text-align: center;float: left;color: #ff0000;">
          {{scope.row.buyVol}}
        </p>
      </template>
    </el-table-column>
    <el-table-column prop="sellVol" label="SellVol" sortable filter-placement="bottom-end">
      <template slot-scope="scope">
        <p style="text-align: center;float: left;color: #008000;">
          {{scope.row.buyVol}}
        </p>
        <!-- <p style="background-color: #ff0000; border-radius: 5px;text-align: center;">
           <font color="#ffffff"> {{scope.row.sellVol}} %</font>
        </p> -->
      </template>
    </el-table-column>
  </el-table>
  </mu-flex>
</template>

<script>
  export default {
    data() {
      return {
        // tableData: []
        // //表格
        tableData: [],
        // pageIndex: 1,
        // //下拉刷新，上拉加载
        // refreshing: false,
        // loadings: false,
        // loadedall: false
      }
    },
    mounted() {
      // this.loadData();
      // setInterval(() => { //setInterval换个名字就行了
      //   // console.log(this.$route.path);
      //   if (this.$route.path != '/M/Transaction') return;
      //   this.loadData();
      // }, 5 * 1000) //设置时间，这里是5秒

      // this.loadData();
    },
    methods: {
      formatter(row, column) {
        return row.num;
      },
      setTableData(data) {
        this.tableData = data;
        // console.log(":::::::::"+this.CurrentData);
      }
    },
    components: {
    }
  };
</script>

<style>
  #T_Details .el-table .el-table__cell{
    padding: 0px 0;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Transaction/Details/T_Details_List.vue